// --------------------------------------------------------------------------
// Generic toggling module used across the site
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function init() {
        var jqToggle = context.find('.toggle'),
            openClass = 'is-open';

        /**
         * Add click event to toggle handlers
         */
        context.on('click', '.toggle', function () {
            $(this).toggleClass(openClass);
            if (typeof $(this).data('toggle-fade') !== 'undefined') {
                $(this).next().fadeToggle(200);
            } else {
                $(this).next().slideToggle();
            }
        });

        $(window).resize(function () {
            //check if desktop - if so remove all styles
            if (jqToggle.css('display') === 'none') {
                jqToggle.next().removeAttr('style');
                jqToggle.removeClass(openClass);
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/module-toggle.js
// module id = 193
// module chunks = 0